import $ from 'jquery'
import _template from 'lodash/template'
import _templateSettings from 'lodash/templateSettings'
import _fromPairs from 'lodash/fromPairs'
import _each from 'lodash/each'
import UAParser from 'ua-parser-js'

_templateSettings.escape = /\[%-([\s\S]+?)%\]/g
_templateSettings.evaluate = /\[%([\s\S]+?)%\]/g
_templateSettings.interpolate = /\[%=([\s\S]+?)%\]/g
_templateSettings.variable = "data"

let csrf_token = null
let errors = null
let myinfo = null

export function get_errors () {
  if (errors != null) {
    return errors
  }
  return errors = new Promise((resolve, reject) => {
    get_json('/errors')
      .then((r) => {
        let { errorlist } = r
        resolve({
          errorlist,
          byname: _fromPairs(errorlist.map((a) => [ a.name, a ])),
          bycode: _fromPairs(errorlist.map((a) => [ a.code, a ])),
        })
      })
      .catch((err) => {
        errors = null
        reject(err)
      })
  })
}

export function get_csrf () {
  if (csrf_token) {
    return csrf_token
  }
  return csrf_token = new Promise((resolve, reject) => {
    get_json('/csrf-token')
      .then((r) => resolve(r.token))
      .catch((err) => {
        csrf_token = null
        reject(err)
      })
  })
}

export async function get_json (url) {
  let resp = await fetch(url, {
    headers: {
      'Accept': 'application/json',
    },
  })
  let respdata = await resp.json()
  if (!respdata || respdata.error) {
    throw (respdata.error || new Error('Unexpected response!'))
  }
  return respdata
}

export async function post_json (url, data) {
  let resp = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'x-csrf-token': await get_csrf(),
    },
    body: JSON.stringify(data),
  })
  let respdata = await resp.json()
  if (!respdata || respdata.error) {
    throw (respdata.error || new Error('Unexpected response!'))
  }
  return respdata
}

export async function alert_error (error) {
  console.error(error)
  let title = error.code ? `Error [${error.code}]` : error.title || "Error"
  let message = error.message ? error.message : error+''
  let $modal = $('#message-modal')
  $modal.find('.modal-title').text(title)
  $modal.find('.message').text(message)
  $modal.modal('show')
}

export function alert_message (title, message) {
  let $modal = $('#message-modal')
  $modal.find('.modal-title').text(title)
  $modal.find('.message').text(message)
  $modal.modal('show')
  return $modal
}

export function alert_message_html (title, message) {
  let $modal = $('#message-modal')
  $modal.find('.modal-title').text(title)
  $modal.find('.message').html(message)
  $modal.modal('show')
  return $modal
}

export function eval_html_template (tmplsel, data, setelm) {
  let $tmpl = $(tmplsel)
  if ($tmpl.length == 0) {
    throw new Error('template does not exists, ' + tmplsel)
  }
  let $tmpelm = $(setelm || '<div/>')
  let tmpl = $tmpl[0]._template = $tmpl[0]._template || _template($tmpl.html())
  $tmpelm.html(tmpl(data))
  if (setelm) {
    return setelm
  } else {
    return $tmpelm.find('> *')[0]
  }
}

export function get_myinfo () {
  if (myinfo) {
    return myinfo
  }
  return myinfo = new Promise((resolve, reject) => {
    get_json('/users/myinfo')
      .then((r) => resolve(r.data))
      .catch((err) => {
        if (err.name == 'NOT_FOUND') {
          resolve(null)
        } else {
          reject(err)
        }
      })
  })
}

export function clear_myinfo () {
  myinfo = null
}

export function has_user_loggedin (myinfo) {
  return myinfo != null && !!myinfo.registered
}

export function utf8hex_to_string (s) {
  if (!(s.length % 2 == 0)) {
    throw new Error('Invalid value')
  }
  let v = ''
  for (let i = 0; i < s.length; i += 2) {
    v += '%' + s.substring(i, i + 2)
  }
  return decodeURIComponent(v)
}

export function dollars_to_cents (s) {
  if (typeof s == 'number') {
    s = s+''
  }
  if (typeof s != 'string') {
    return NaN
  }
  let idx = s.indexOf('.')
  if (idx != -1) {
    let maxdec = 2
    let decpart = s.substring(idx + 1)
    return parseInt(s.substring(0, idx)) * 100 +
      parseInt((parseInt('1' + decpart)+'').substring(0, maxdec+1)) - 100
  } else {
    return parseInt(s) * 100
  }
}

export function cents_to_dollars (v) {
  if (typeof v != 'number') {
    return NaN
  }
  v = parseInt(v)+''
  return v.substring(0, v.length - 2) + '.' + v.substring(v.length - 2)
}

let order_status_to_label = {
  unpaid: {
    text: 'Unpaid',
    class_names: 'badge badge-secondary',
  },
  paid: {
    text: 'Paid',
    class_names: 'badge badge-success',
  },
  expired: {
    text: 'Expired',
    class_names: 'badge badge-light',
  },
  payment_failed: {
    text: 'Payment Failed',
    class_names: 'badge badge-danger',
  },
  unknown: {
    text: 'Unknown',
    class_names: 'badge badge-light',
  },
}
let order_line_status_to_label = {
  pending: {
    text: 'Pending',
    class_names: 'badge badge-secondary',
  },
  failed: {
    text: 'Failed',
    class_names: 'badge badge-danger',
  },
  credited: {
    text: 'Credited',
    class_names: 'badge badge-success',
  },
  unknown: {
    text: 'Unknown',
    class_names: 'badge badge-light',
  },
}
export function populate_order_with_lines (order) {
  let total_price = 0
  for (let line of order.lines) {
    total_price += dollars_to_cents(line.item_price)
    line.status_label = order_line_status_to_label[line.status] || order_line_status_to_label.unknown
  }
  order.total_price = cents_to_dollars(total_price)
  order.status_label = order_status_to_label[order.status] || order_status_to_label.unknown
}

export function getRecommendedDownloadLinkByUserAgent (exec_list) {
  let PLATFORM_MAP_LIST = [
    {
      ua_platform: 'Linux',
      target_platform: 'linux',
    },
    {
      ua_platform: 'Windows',
      target_platform: 'win',
    },
    {
      ua_platform: 'Mac OS',
      target_platform: 'mac',
    },
  ]
  let ARCH_MAP_LIST = [
    {
      ua_arch_list: ['amd64', 'ia64'],
      ua_platform_list: ['Linux'],
      target_arch: 'x86_64',
    },
    {
      ua_arch_list: ['amd64', 'ia64'],
      ua_platform_list: ['Windows', 'Mac OS'],
      target_arch: 'x64',
    },
    {
      ua_arch_list: ['arm64'],
      target_arch: 'arm64',
    }
  ]
  
  let ua = (new UAParser()).getResult()

  let arch, platform

  {
    let tmp = PLATFORM_MAP_LIST.find((a) => a.ua_platform == ua.os.name)
    if (tmp) {
      platform = tmp.target_platform
    }
  }

  if (platform) {
    let tmp = ARCH_MAP_LIST.find((a) => a.ua_arch_list.indexOf(ua.cpu.architecture) != -1 && a.ua_platform_list.indexOf(ua.os.name) != -1)
    if (tmp) {
      arch = tmp.target_arch
    }
  }
  let exec_file = null
  if (arch && platform) {
    exec_file = exec_list.find((a) => a.platform == platform && a.arch == arch)
  }
  return exec_file
}
